import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { formatarData } from "../../../Funcoes/FormatarData";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import ColabMultiSelector from "../../../Componentes/Utils/ColabMultiSelector";
import Tabela2 from "../../../Componentes/Utils/Tabela2";
import styled from "styled-components";
import MultiFileUploader from "../../../Componentes/Utils/MultiFileUploader";
import { FaArrowDown } from "react-icons/fa";
import { AiOutlineFilePdf, AiOutlineFileImage, AiOutlineFileWord, AiOutlineFileExcel, AiOutlineFileUnknown } from "react-icons/ai";
import { saveAs } from "file-saver";

import useApi from "../../../hooks/useApi";
const ContainerTabela = styled.div`
    width: 100%;
    margin-top: 15px;
`
const ContainerAnexos = styled.div`
    margin-top: 15px;
    width: 100%;
    p {
        font-size: 14px;
        font-weight: 500;
        color: #555;
        margin: 0 0 5px 5px;
    }
`
const ContainerAnexo = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    background-color: #f6f8fa;
    border: 1px solid #ccc;
    margin-bottom: 5px;
    border-radius: 10px;
`
const AnexoIconContainer = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-right: 10px;
    flex-shrink: 0;
    box-sizing: border-box;
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
`
const AnexoNome = styled.p`
    font-size: 14px;
    color: #333;
    margin: 0;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
const ContainerAnexoDownload = styled.div`
    margin: auto 0 auto auto;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #e0e0e0;
    transition: all 0.2s;
    &:hover {
        background-color: #d0d0d0;
        scale: 1.05;
    }
`
const IconeDownload = styled(FaArrowDown)`
    color: #555;
    width: 50%;
    height: 50%;
`

const ModalEditInvestigacao = ({ fecharModal, obj, update }) => {
    const api = useApi();


    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [formValues, setFormValues] = useState({
        centroCusto: "",
        contrato: "",
        responsavelPreenchimento: "",
        areaOcorrencia: "",
        liderImediato: "",
        equipe: "",
        dataOcorrencia: "",
        ocorrido: "",
        detalhesOcorrencia: "",
        tipoAcidente: "",
        classificacao: "",
        naturezaLesoes: "",
        partesLesionadas: "",
        nCat: "",
        causaRaiz: "",
        correcao: "",
        acaoCorretiva: "",
        responsavelPlanoAcao: "",
        prazo: "",
        custos: "",
        finalizado: "",
        dataFinalizacao: null
    });
    const [envolvidos, setEnvolvidos] = useState([]);
    const [listaAnexos, setListaAnexos] = useState([]);

    const [membrosSesmt, setMembrosSesmt] = useState([]);
    const [repsCipa, setRepsCipa] = useState([]);
    const [acidentados, setAcidentados] = useState([]);
    const [testemunhas, setTestemunhas] = useState([]);

    const [lideres, setLideres] = useState([]);

    const [anexos, setAnexos] = useState([]);

    const [editing, setEditing] = useState(false);
    const [finalizado, setFinalizado] = useState(false);

    const getLideres = async (responsavelMatricula, responsavelNome) => {

        try {

            const { data } = await api.get("/Painel/assets/php/getLideres.php");
            console.log(data);

            //Verificar se o responsavel está na lista de líderes, se não estiver, adicioná-lo
            const respLider = data.find(lider => lider.MATRICULA === responsavelMatricula);
            if (!respLider && responsavelMatricula !== null) {
                data.push({ MATRICULA: responsavelMatricula, RA_NOMECMP: responsavelNome });
            }

            setLideres(data);

        } catch (error) {

            console.log(error);

        }

    }

    const fectchData = async () => {

        try {

            setLoading(true);

            const { data } = await api.get(`/Painel/API/Desvios/GetInvestigacaoById/index.php?id=${obj.id}`);
            console.log(data);

            setFormValues({
                centroCusto: data.centro_custo,
                contrato: data.contrato,
                responsavelPreenchimento: data.usuario,
                areaOcorrencia: data.area,
                liderImediato: data.lider,
                equipe: data.equipe,
                dataOcorrencia: data.data_ocorrido,
                ocorrido: data.ocorrido,
                detalhesOcorrencia: data.descricao_detalhada,
                tipoAcidente: data.tipo_acidente,
                classificacao: data.classificacao,
                naturezaLesoes: data.natureza_lesoes,
                partesLesionadas: data.partes_lesionadas,
                nCat: data.cat,
                causaRaiz: data.causa_raiz,
                correcao: data.correcao,
                acaoCorretiva: data.acao_corretiva,
                responsavelPlanoAcao: data.responsavel_matricula,
                prazo: data.prazo,
                custos: data.custo,
                finalizado: data.resolvido,
                dataFinalizacao: data.data_resolucao || null
            })

            await getLideres(data.responsavel_matricula, data.responsavel_nome);

            if (data.resolvido === 1) {
                setFinalizado(true);
                setEnvolvidos(data.envolvidos);
                setListaAnexos(data.anexos);
            } else if (data.acao_corretiva !== null) {
                setEnvolvidos(data.envolvidos);
                setEditing(true);
                setListaAnexos(data.anexos);
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {

        if (obj) {

            fectchData();

        }

    }, [obj])

    const handleChange = (e) => {

        let { name, value } = e.target;

        //Caso o campo seja 'custos', converte para o formato 0.00 enquanto o usuário digita
        if (name === "custos") {
            value = value.replace(/[^0-9]/g, ""); //Remove tudo que não for número
            value = (parseInt(value) / 100).toFixed(2); //Converte para decimal
        }

        setFormValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));

    }

    const submitForm = async (e) => {

        e.preventDefault();

        if ((!finalizado && !editing) && (membrosSesmt.length === 0 || repsCipa.length === 0 || acidentados.length === 0 || testemunhas.length === 0)) {
            alert("Por favor, preencha todos os colaboradores envolvidos na investigação.");
            return;
        }

        setSaving(true);

        try {

            const formData = new FormData();
            if (!editing) {

                formData.append("detalhesOcorrencia", formValues.detalhesOcorrencia);
                formData.append("tipoAcidente", formValues.tipoAcidente);
                formData.append("classificacao", formValues.classificacao);
                formData.append("naturezaLesoes", formValues.naturezaLesoes);
                formData.append("partesLesionadas", formValues.partesLesionadas);
                formData.append("nCat", formValues.nCat);
                formData.append("causaRaiz", formValues.causaRaiz);
                formData.append("correcao", formValues.correcao);
                formData.append("acaoCorretiva", formValues.acaoCorretiva);
                formData.append("responsavelPlanoAcao", formValues.responsavelPlanoAcao);
                formData.append("prazo", formValues.prazo);

            }

            formData.append("custos", formValues.custos);
            formData.append("finalizado", formValues.finalizado);
            formData.append("dataFinalizacao", formValues.dataFinalizacao);
            formData.append("id", obj.id);

            formData.append("membrosSesmt", JSON.stringify(membrosSesmt));
            formData.append("repsCipa", JSON.stringify(repsCipa));
            formData.append("acidentados", JSON.stringify(acidentados));
            formData.append("testemunhas", JSON.stringify(testemunhas));

            let url = editing ? "/Painel/API/Desvios/UpdateInvestigacao/" : "/Painel/API/Desvios/SaveInvestigacao/"

            const { data } = await api.post(url, formData, {
                withCredentials: true
            });

            console.log(data);

            await update();
            fecharModal();

        } catch (error) {
            console.log(error);
        } finally {
            setSaving(false);
        }

    }

    const getFileIcon = (filename) => {
        const name = filename.toLowerCase();

        if (name.endsWith(".png") || name.endsWith(".jpg")) return <AiOutlineFileImage size={22} color="#4a90e2" />;
        if (name.endsWith(".pdf")) return <AiOutlineFilePdf size={22} color="#e63946" />;
        if (name.endsWith(".doc") || name.endsWith(".docx")) return <AiOutlineFileWord size={22} color="#2a6db0" />;
        if (name.endsWith(".xls") || name.endsWith(".xlsx")) return <AiOutlineFileExcel size={22} color="#207245" />;

        return <AiOutlineFileUnknown size={22} color="#555" />;

    }

    const downloadAnexo = (url) => {

        saveAs(url, url.split("/").pop() );

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={fecharModal} >
                    {
                        loading ? (
                            <SmallLoading />
                        ) : (
                            <Formulario onSubmit={submitForm} >
                                <FormComp
                                    title="CENTRO CUSTO"
                                    type="text"
                                    valor={formValues.centroCusto}
                                    readOnly={true}
                                />
                                <FormComp
                                    title="CONTRATO"
                                    type="text"
                                    valor={formValues.contrato}
                                    readOnly={true}
                                />
                                <FormComp
                                    title="RESPONSÁVEL PELO PREENCHIMENTO"
                                    type="text"
                                    valor={formValues.responsavelPreenchimento}
                                    readOnly={true}
                                />
                                <FormComp
                                    title="ÁREA DA OCORRÊNCIA"
                                    type="text"
                                    valor={formValues.areaOcorrencia}
                                    readOnly={true}
                                />
                                <FormComp
                                    title="LÍDER IMEDIATO"
                                    type="text"
                                    valor={formValues.liderImediato}
                                    readOnly={true}
                                />
                                <FormComp
                                    title="EQUIPE"
                                    type="text"
                                    valor={formValues.equipe}
                                    readOnly={true}
                                />
                                <FormComp
                                    title="DATA DE OCORRÊNCIA"
                                    type="text"
                                    valor={formValues.dataOcorrencia ? formatarData(formValues.dataOcorrencia) : ""}
                                    readOnly={true}
                                />
                                <FormComp
                                    title="OCORRIDO"
                                    type="textarea"
                                    valor={formValues.ocorrido}
                                    readOnly={true}
                                />
                                {
                                    (editing || finalizado) ? (
                                        <>
                                            <ContainerTabela>
                                                <Tabela2>
                                                    <thead>
                                                        <tr>
                                                            <th colSpan={3} >COLABORADORES ENVOLVIDOS</th>
                                                        </tr>
                                                        <tr>
                                                            <th>NOME</th>
                                                            <th>FUNÇÃO</th>
                                                            <th>RESPONSABILIDADE</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            envolvidos.map((colab) => (
                                                                <tr key={colab.id} >
                                                                    <td>{colab.nome}</td>
                                                                    <td>{colab.funcao}</td>
                                                                    <td>{colab.tipo}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Tabela2>
                                            </ContainerTabela>
                                        </>
                                    ) : (
                                        <>
                                            <ColabMultiSelector
                                                colaboradores={membrosSesmt}
                                                setColaboradores={setMembrosSesmt}
                                                required
                                                titulo="MEMBROS DO SESMT"
                                                name="MembrosSesmt"
                                            />
                                            <ColabMultiSelector
                                                colaboradores={repsCipa}
                                                setColaboradores={setRepsCipa}
                                                required
                                                titulo="REPRESENTANTES DA CIPA"
                                                name="RepCipa"
                                            />
                                            <ColabMultiSelector
                                                colaboradores={acidentados}
                                                setColaboradores={setAcidentados}
                                                required
                                                titulo="ACIDENTADOS"
                                                name="Acidentados"
                                            />
                                            <ColabMultiSelector
                                                colaboradores={testemunhas}
                                                setColaboradores={setTestemunhas}
                                                required
                                                titulo="TESTEMUNHAS"
                                                name="Testemunhas"
                                            />
                                        </>
                                    )
                                }
                                <FormComp
                                    title="DETALHES DA OCORRÊNCIA"
                                    type="textarea"
                                    valor={formValues.detalhesOcorrencia}
                                    readOnly={editing || finalizado}
                                    changeFunc={handleChange}
                                    name="detalhesOcorrencia"
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="TIPO DO ACIDENTE / INCIDENTE"
                                    type="select"
                                    options={[
                                        "DANOS MATERIAIS",
                                        "DOMESTICO",
                                        "TIPICO",
                                        "TRAJETO"
                                    ]}
                                    valor={formValues.tipoAcidente}
                                    changeFunc={handleChange}
                                    name="tipoAcidente"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="CLASSIFICAÇÃO"
                                    type="select"
                                    options={[
                                        "AAM",
                                        "ACA",
                                        "ASA",
                                        "INCIDENTE",
                                        "NRT",
                                        "SAA"
                                    ]}
                                    valor={formValues.classificacao}
                                    changeFunc={handleChange}
                                    name="classificacao"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="NATUREZA DAS LESÕES"
                                    type="select"
                                    options={[
                                        "N/A",
                                        "AFOGAMENTO",
                                        "AMPUTAÇÃO",
                                        "ASFIXIA",
                                        "CONCUSSÃO",
                                        "CONTUSÃO",
                                        "CORPOS ESTRANHOS",
                                        "CORTE, ABRASÃO",
                                        "DESLOCAMENTO",
                                        "DISTENSÃO",
                                        "DOENÇA",
                                        "ENVENENAMENTO",
                                        "FRATURA",
                                        "HÉRNIA",
                                        "IRRADIAÇÃO",
                                        "LACERAÇÃO",
                                        "LESÃO DE ESMAGAMENTO",
                                        "LESÕES MÚLTIPLAS",
                                        "PERFURAÇÃO",
                                        "QUEIMADURA"
                                    ]}
                                    valor={formValues.naturezaLesoes}
                                    changeFunc={handleChange}
                                    name="naturezaLesoes"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="PARTES LESIONADAS DO CORPO"
                                    type="select"
                                    options={[
                                        "N/A",
                                        "ABDÔMEN",
                                        "ANTEBRAÇO",
                                        "BRAÇO",
                                        "CABEÇA",
                                        "CINTURA",
                                        "COSTAS",
                                        "COTOVELO",
                                        "DORSO",
                                        "ESPINHA",
                                        "FACE",
                                        "JOELHO, TORNOZELO, PERNA",
                                        "MÃO, DEDOS E POLEGAR",
                                        "OLHOS",
                                        "OMBRO",
                                        "ÓRGÃOS INTERNOS",
                                        "OUVIDOS",
                                        "PARTES MÚLTIPLAS",
                                        "PÉ E DEDOS DO PÉ",
                                        "PEITO",
                                        "PÉLVIS",
                                        "PESCOÇO",
                                        "QUADRIL"
                                    ]}
                                    valor={formValues.partesLesionadas}
                                    changeFunc={handleChange}
                                    name="partesLesionadas"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="Nº DA CAT"
                                    type="text"
                                    valor={formValues.nCat}
                                    changeFunc={handleChange}
                                    name="nCat"
                                    readOnly={editing || finalizado}
                                />
                                <FormComp
                                    title="CAUSA RAIZ"
                                    type="textarea"
                                    valor={formValues.causaRaiz}
                                    changeFunc={handleChange}
                                    name="causaRaiz"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="CORREÇÃO"
                                    type="textarea"
                                    valor={formValues.correcao}
                                    changeFunc={handleChange}
                                    name="correcao"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="AÇÃO CORRETIVA"
                                    type="textarea"
                                    valor={formValues.acaoCorretiva}
                                    changeFunc={handleChange}
                                    name="acaoCorretiva"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                {
                                    (!finalizado) && (
                                        <MultiFileUploader
                                            files={anexos}
                                            setFiles={setAnexos}
                                        />
                                    )
                                }
                                {
                                    (finalizado || editing) && (
                                        <ContainerAnexos>
                                            <p>ANEXOS</p>
                                            {
                                                listaAnexos.map((anexo) => (
                                                    <ContainerAnexo key={anexo.id} >
                                                        <AnexoIconContainer>
                                                            {getFileIcon(anexo.url)}
                                                        </AnexoIconContainer>
                                                        <AnexoNome>{anexo.filename}</AnexoNome>
                                                        <ContainerAnexoDownload>
                                                            <IconeDownload onClick={() => downloadAnexo(anexo.url)} />
                                                        </ContainerAnexoDownload>
                                                    </ContainerAnexo>
                                                ))
                                            }
                                        </ContainerAnexos>
                                    )
                                }
                                <FormComp
                                    title="RESPONSÁVEL PELO PLANO DE AÇÃO"
                                    type="select"
                                    obj
                                    options={lideres.map(lider => ({ value: lider.MATRICULA, label: lider.RA_NOMECMP }))}
                                    valor={formValues.responsavelPlanoAcao}
                                    changeFunc={handleChange}
                                    name="responsavelPlanoAcao"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="PRAZO"
                                    type="date"
                                    valor={formValues.prazo}
                                    changeFunc={handleChange}
                                    name="prazo"
                                    readOnly={editing || finalizado}
                                    required={!editing && !finalizado}
                                />
                                <FormComp
                                    title="CUSTOS"
                                    type="number"
                                    valor={formValues.custos}
                                    changeFunc={handleChange}
                                    name="custos"
                                    readOnly={finalizado}
                                />
                                <FormComp
                                    title="FINALIZADO"
                                    type="select"
                                    obj
                                    options={[
                                        { value: 1, label: "SIM" },
                                        { value: 0, label: "NÃO" }
                                    ]}
                                    valor={formValues.finalizado}
                                    changeFunc={handleChange}
                                    name="finalizado"
                                    readOnly={finalizado}
                                />
                                <FormComp
                                    title="DATA DE FINALIZAÇÃO"
                                    type="date"
                                    valor={formValues.dataFinalizacao}
                                    changeFunc={handleChange}
                                    name="dataFinalizacao"
                                    readOnly={finalizado}
                                />
                                {
                                    //Mostrar botão de salvar apenas se não estiver finalizado
                                    !finalizado && (
                                        <FormComp
                                            type="submit"
                                            valor="SALVAR"
                                        />
                                    )
                                }
                            </Formulario>
                        )
                    }
                    {
                        saving && (
                            <Overlay state={true} >
                                <Modal size="sm" >
                                    <SmallLoading />
                                </Modal>
                            </Overlay>
                        )
                    }
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalEditInvestigacao;